import PageHero from "@/components/common/PageHero";

const sections = [
  { h: "Acceptance of Terms", b: "By accessing or using kavionglobal.com, you agree to be bound by these Terms & Conditions." },
  { h: "Services", b: "Kavion Global Limited provides eCommerce growth services including but not limited to Shopify design, conversion rate optimization, and performance marketing. All engagements are governed by individual client agreements." },
  { h: "Intellectual Property", b: "All content on this website — including copy, design, logos, and case studies — is the property of Kavion Global Limited unless otherwise stated. You may not reproduce or redistribute without written permission." },
  { h: "Client Confidentiality", b: "Client information shared during engagements is treated as confidential and used solely for service delivery." },
  { h: "Limitation of Liability", b: "Kavion Global Limited is not liable for indirect or consequential damages arising from use of our website. Service-related liability is governed by signed engagement agreements." },
  { h: "Modifications", b: "We may update these terms at any time. Continued use of the website constitutes acceptance of the updated terms." },
  { h: "Governing Law", b: "These terms are governed by and construed in accordance with the laws of the Hong Kong Special Administrative Region (Hong Kong SAR). Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts of the Hong Kong SAR." },
  { h: "Contact", b: "Questions about these terms? Email info@kavionglobal.com." },
];

export default function TermsPage() {
  return (
    <main data-testid="terms-page">
      <PageHero eyebrow="Legal" title="Terms & Conditions" subtitle="Last updated: February 2026" />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-display text-2xl font-bold text-white">{s.h}</h2>
              <p className="mt-3 text-zinc-400 leading-relaxed">{s.b}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
